// set image borad
export const setImageBoard = showImageBoard => ({
  type: "SET_IMAGE_BOARD",
  showImageBoard
});
